// extracted by mini-css-extract-plugin
module.exports = {"card":"CardList_card__3vSsC","programsWrapper":"CardList_programsWrapper__pw8kC","maxFourCardsInARow":"CardList_maxFourCardsInARow__qrPG_"};